import Record from "slotworks/model/gameplay/records/record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";
import SlotDefinition from "slotworks/model/slot-definition";
import RainbowStacksSpinRecord from "integration/revolver/schema/spin-record";

const JACKPOT_SYMBOLS = [ "J1", "J2", "J3", "J4"];

class RainbowStacksAnticipationSupplement implements DataProcessorSupplement {

    public process(record: Record) {
        if (SlotDefinition.symbolDefinitions) {
            if (record && record instanceof RainbowStacksSpinRecord && record.grid.length) {
                
                const reels: string[][] = record.grid;
                
                for (const symbolId of reels[0]) {
                    if(symbolId == "J0") {
                        record.anticipations.landSymbols[0].push(symbolId);
                    }
                }

                // if(record.triggersRespin) {
                //     for (const symbolId of reels[4]) {
                //         if(JACKPOT_SYMBOLS.indexOf(symbolId) >= 0) {
                //             record.anticipations.landSymbols[4].push(symbolId);
                //         }
                //     }
                // }

                // for (const symbolId of reels[3]) {
                //     if(symbolId == "SC") {
                //         record.anticipations.landSymbols[3].push(symbolId);
                //     }
                // }
            }
        }
    }

}

export default new RainbowStacksAnticipationSupplement();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/model/anticipation-supplement.ts